import r from "./themes/nova.js";
import t from "./themes/royal-punk.js";
function u(e) {
  return JSON.parse(JSON.stringify(n(e)));
}
function n(e) {
  switch (e) {
    case "royal-punk":
      return t;
    case "nova":
    default:
      return r;
  }
}
function a(e) {
  return typeof e == "string" ? n(e) : e ?? r;
}
export {
  u as createTheme,
  n as namedTheme,
  a as normalizeTheme
};
